<template>
  <vs-popup class="customer-sample-order-create-popup"
            title="SAMPLE ORDER CREATE"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card id="popup" no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSampleOrder)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-2/3 w-full md:mb-0">
                  <vs-table :data="cartItems" stripe>
                    <template slot="header">
                      <h3>

                      </h3>
                    </template>
                    <template slot="thead">
                      <vs-th width="50">FINISHED PRODUCT NAME</vs-th>
                      <vs-th width="30">QUANTITY (GRAMS)</vs-th>
                      <vs-th width="20"></vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].formulation_name">
                          {{ data[indextr].formulation_name }}
                        </vs-td>
                        
                        <vs-td :data="data[indextr].quantity">
                          {{ data[indextr].quantity }}
                        </vs-td>

                        <vs-td :data="data[indextr].formulation_id">
                          <vx-tooltip class="" text="Remove from cart" position="left">
                            <vs-button @click="onClickRemoveFromCart(data[indextr].id)"
                                       size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                          </vx-tooltip>
                        </vs-td>

                      </vs-tr>
                    </template>

                  </vs-table>
            </div>

              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <vx-card>
                <div class="vx-row mb-3">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="formulation_items" name="formulation_items" rules="required" v-slot="{ errors }">
                      <small class="label">Select a delivery address</small>
                      <v-select
                        v-on:input="onChangeSelectDeliveryAddress"
                        name="formulation_items" placeholder=""
                        v-model="selectedAddress" :reduce="option => option"
                        label="country"
                        :options="addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            <span style="font-weight: normal">{{ option.name }}</span> <br>
                            <span style="font-weight: normal">{{ option.line1 }}</span> <br>
                            <span style="font-weight: normal">{{ option.line2 }}</span> <br>
                            <span style="font-weight: normal">{{ option.line3 }}</span> <br>
                            <span style="font-weight: normal">{{ option.town_state }}</span> <br>
                            <span style="font-weight: normal">{{ option.post_code }}</span> <br>
                            <span style="font-weight: normal">{{ option.country }}</span> <br>
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            <span style="font-weight: normal">{{ option.name }}</span> <br>
                            <span style="font-weight: normal">{{ option.line1 }}</span> <br>
                            <span style="font-weight: normal">{{ option.line2 }}</span> <br>
                            <span style="font-weight: normal">{{ option.line3 }}</span> <br>
                            <span style="font-weight: normal">{{ option.town_state }}</span> <br>
                            <span style="font-weight: normal">{{ option.post_code }}</span> <br>
                            <span style="font-weight: normal">{{ option.country }}</span> <br>
                          </div>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                      <small class="label">Address Name</small>
                      <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                      <small class="label">Address Line 1</small>
                      <vs-input v-model="form.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line2" name="line2" rules="required" v-slot="{ errors }">
                      <small class="label">Address Line 2</small>
                      <vs-input v-model="form.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 3</small>
                      <vs-input v-model="form.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                      <small class="label">Town / State</small>
                      <vs-input v-model="form.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                      <small class="label">Postal Code</small>
                      <vs-input v-model="form.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                                label="name" v-model="form.country" :reduce="option => option.name"
                                :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>


                <div class="vx-row mb-3">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                      <small class="label">Delivery Instructions</small>
                      <vs-textarea class="mb-0" v-model="form.delivery_instruction" height="150px" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                </vx-card>
              </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Order</vs-button>
            <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction: '',
        formulation_items: []
      },
      countryCodes: [],
      customerUsers: [],
      isCreateFromMainMenu: false,
      customers: [],
      formulations: [],
      addresses: [],
      selectedAddress: '',
      cartItems: []
    }
  }

export default {
  name: 'TrackingImagePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        await this.getCountryCodes()
        await this.getAddresses()
        await this.getItemsInItemsCart()
        // this.getFormulations()
        this.open = true;
      } catch (error) {

      }
    },
    async onClickClose() {
      const vue = this;
      this.open = false
      await vue.$parent.onlyRefreshData()
    },
    async onClickCreateSampleOrder () {
      const vue = this;
      this.$vs.loading()
       try {
         this.form.customer_id = this.id
         
         this.form.formulation_items = this.cartItems.map((m) => {
           return { id: m.formulation_id, quantity: m.quantity }
         })

         await CustomerRepository.createCustomerSampleOrder(this.form)
         this.showSuccessMessage('Sample order created successfully')
         this.open = false;
         await vue.$parent.refreshData()

       }catch (e) {
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async getFormulations() {
      this.$vs.loading()
      const {data} = await FormulationsRepository.get(1, '', 50, '')
      this.formulations =  data.data
      this.$vs.loading.close()
    },
    async getCountryCodes() {
      this.$vs.loading()
      this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
      this.$vs.loading.close()
    },
    async getAddresses() {
      this.$vs.loading()
      this.addresses = (await CustomerRepository.getSampleDeliveryAddresses()).data.data;
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    doCheckItems(data) {
      console.log(data)
    },
    async getItemsInItemsCart() {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        const {data} = (await CustomerRepository.getItemsInItemsCart(this.id)).data
        this.cartItems = data
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async onClickRemoveFromCart(id) {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        await CustomerRepository.removeFormulationsFromCart(id)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Removed from cart')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    onChangeSelectDeliveryAddress(selected) {
      this.form.name = selected.name
      this.form.line1 = selected.line1
      this.form.line2 = selected.line2
      this.form.line3 = selected.line3
      this.form.town_state = selected.town_state
      this.form.post_code = selected.post_code
      this.form.country = selected.country
      this.form.delivery_instruction = selected.additional_info
    },


  },
  async mounted () {

  },
  computed: {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    min-height: 80% !important;
    min-width: 80% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
